import { convertFromStringToBool } from '@hooks/useFilterObject';
import { APIRequestParamNames } from '@src/types/apiRequestParamNames';
import { SorteringType } from '@src/types/minhelseentities';
import { URLQueryParamNames } from '@src/types/urlQueryParamNames';
import { ASC } from '@src/types/verktoyFilterTypes';

import type { FilterURLQuery } from '@src/types/filterURLQuery';
import type { VerktoyFilterState } from '@src/types/stateTypes';

export const getQueryURLFromState = (isLoggedIn: boolean, verktoyFilters?: VerktoyFilterState): FilterURLQuery => {
  return verktoyFilters
    ? {
        ...(!isLoggedIn && verktoyFilters.IsAnonymCheckboxChecked && { [URLQueryParamNames.StotterAnonymOppstart]: true }),
        ...(verktoyFilters.SokeString && { [URLQueryParamNames.Sok]: verktoyFilters.SokeString }),
        ...(verktoyFilters.Fagomrader?.length > 0 && { [URLQueryParamNames.Fagomrade]: verktoyFilters.Fagomrader }),
        ...(verktoyFilters.VerktoyTyper?.length > 0 && { [URLQueryParamNames.VerktoyType]: verktoyFilters.VerktoyTyper }),
        ...(verktoyFilters.Malgrupper?.length > 0 && { [URLQueryParamNames.Malgruppe]: verktoyFilters.Malgrupper }),
        ...(verktoyFilters.Sortering && { Sortering: verktoyFilters.Sortering }),
        ...(verktoyFilters.SorterStigende && {
          [URLQueryParamNames.SorterStigende]: convertFromStringToBool(verktoyFilters.SorterStigende),
        }),
      }
    : {};
};

export const getAPIRequestURLFromState = (isLoggedIn: boolean, verktoyFilters?: VerktoyFilterState): URLSearchParams => {
  const params = new URLSearchParams();
  if (verktoyFilters) {
    if (!isLoggedIn && verktoyFilters.IsAnonymCheckboxChecked) {
      params.append(APIRequestParamNames.StotterAnonymOppstart, 'true');
    }
    if (verktoyFilters.SokeString) {
      params.append(APIRequestParamNames.Sok, verktoyFilters.SokeString);
    }
    if (verktoyFilters.Fagomrader && verktoyFilters.Fagomrader.length > 0) {
      verktoyFilters.Fagomrader.forEach(fag => params.append(APIRequestParamNames.Fagomrader, fag));
    }
    if (verktoyFilters.VerktoyTyper && verktoyFilters.VerktoyTyper.length > 0) {
      verktoyFilters.VerktoyTyper.forEach(type => params.append(APIRequestParamNames.VerktoyTyper, type));
    }
    if (verktoyFilters.Malgrupper && verktoyFilters.Malgrupper.length > 0) {
      verktoyFilters.Malgrupper.forEach(gruppe => params.append(APIRequestParamNames.Malgrupper, gruppe));
    }
    if (verktoyFilters.Sortering) {
      params.append(APIRequestParamNames.Sortering, verktoyFilters.Sortering);
    }

    const isDefaultSort = verktoyFilters.Sortering === SorteringType[SorteringType.VerktoyNavn] && verktoyFilters.SorterStigende === ASC;

    if (verktoyFilters.SorterStigende && !isDefaultSort) {
      params.append(APIRequestParamNames.Sorterstigende, String(convertFromStringToBool(verktoyFilters.SorterStigende)));
    }
  }
  return params;
};
